import { httpClient } from '../httpClient';

const PREFIX = '/api/user';

/**
 * POST /api/user/signup/
 * @param {object} payload
 */
export function signup(payload) {
  return httpClient
    .post(`${PREFIX}/signup/`, payload)
    .then((res) => res.data);
}

/**
 * POST /api/user/login/
 * @param {{ username: string, password: string }} payload
 */
export function login(payload) {
  return httpClient
    .post(`${PREFIX}/login/`, payload)
    .then((res) => res.data);
}

/**
 * POST /api/user/change_password/
 * @param {{ old_password: string, new_password: string, new_password2: string }} payload
 */
export function changePassword(payload) {
  return httpClient
    .post(`${PREFIX}/change_password/`, payload)
    .then((res) => res.data);
}

/**
 * GET /api/user/
 * @param {import('axios').AxiosRequestConfig} [config]
 */
export function fetchCurrentUser(config = {}) {
  return httpClient
    .get(`${PREFIX}/`, config)
    .then((res) => res.data);
}

/**
 * PATCH /api/user/
 * @param {object} payload
 */
export function updateProfile(payload) {
  return httpClient
    .patch(`${PREFIX}/`, payload)
    .then((res) => res.data);
}

/**
 * POST /api/user/token/refresh/
 * @param {string} refresh
 */
export function refreshAccessToken(refresh) {
  return httpClient
    .post(`${PREFIX}/token/refresh/`, { refresh })
    .then((res) => res.data);
}

/**
 * POST /api/user/logout/
 * @param {string|null} refresh
 */
export function logout(refresh = null) {
  return httpClient
    .post(`${PREFIX}/logout/`, refresh ? { refresh } : {})
    .then((res) => res.data);
}

const ADMIN_PREFIX = '/api/admin';

export function fetchAdminCabinetData() {
  return httpClient.get(`${ADMIN_PREFIX}/cabinet-data/`).then((res) => res.data);
}

export function patchAdminUser(userId, payload) {
  return httpClient.patch(`${ADMIN_PREFIX}/users/${userId}/`, payload).then((res) => res.data);
}

export function deleteAdminUser(userId) {
  return httpClient.delete(`${ADMIN_PREFIX}/users/${userId}/`);
}

export function fetchRolePermissions() {
  return httpClient.get(`${ADMIN_PREFIX}/role-permissions/`).then((res) => res.data);
}

export function patchRolePermissions(payload) {
  return httpClient.patch(`${ADMIN_PREFIX}/role-permissions/`, payload).then((res) => res.data);
}

export function patchRoleModules(payload) {
  return httpClient.patch(`${ADMIN_PREFIX}/role-modules/`, payload).then((res) => res.data);
}

export function createAdminGroup(payload) {
  return httpClient.post(`${ADMIN_PREFIX}/groups/`, payload).then((res) => res.data);
}

export function patchAdminGroup(groupId, payload) {
  return httpClient.patch(`${ADMIN_PREFIX}/groups/${groupId}/`, payload).then((res) => res.data);
}

export function deleteAdminGroup(groupId) {
  return httpClient.delete(`${ADMIN_PREFIX}/groups/${groupId}/`);
}

export function applyAdminGroup(groupId, payload) {
  return httpClient.post(`${ADMIN_PREFIX}/groups/${groupId}/apply/`, payload).then((res) => res.data);
}

export function fetchErrorLogs(params = {}) {
  return httpClient.get(`${ADMIN_PREFIX}/errors/`, { params }).then((res) => res.data);
}

export function fetchErrorLog(errorId) {
  return httpClient.get(`${ADMIN_PREFIX}/errors/${errorId}/`).then((res) => res.data);
}

export function patchErrorLogStatus(errorId, status) {
  return httpClient.patch(`${ADMIN_PREFIX}/errors/${errorId}/`, { status }).then((res) => res.data);
}

export function deleteErrorLog(errorId) {
  return httpClient.delete(`${ADMIN_PREFIX}/errors/${errorId}/`);
}

export function deleteErrorLogs(ids) {
  return httpClient.post(`${ADMIN_PREFIX}/errors/bulk-delete/`, { ids }).then((res) => res.data);
}

export function exportErrorLogs(params = {}) {
  return httpClient.get(`${ADMIN_PREFIX}/errors/export/`, {
    params,
    responseType: 'blob',
    timeout: 60000,
  });
}
